"use strict";
var hlp = require('common/helpers');
var Menu = require('../helpers/menu');
var fieldEntryCtrl = function($scope, $uibModal, $sce, $http) {
  var init = function() {};
  $scope.getQuellen = function(query) {
    if (hlp.isSet($scope.descriptionText)) {
      $scope.descriptionText = null;
      return;
    }
    $http.get('/api/data/quelle/' + encodeURIComponent(query + '.json'), {}).success(function(data, status, headers, config) {
      $scope.descriptionText = data.verses;
    }).catch(function(data, status, headers, config) {}).finally(function() {});
  };
  init();
};
fieldEntryCtrl.$inject = ['$scope', '$uibModal', '$sce', '$http'];
module.exports = fieldEntryCtrl;
